import { DomainModelHelper } from '@digital-platform/shared/domain';
import { PhysicalComponent, PhysicalComponentsSample } from '../interfaces';

export class PhysicalComponentModel implements PhysicalComponent {
  public readonly physicalComponents: PhysicalComponentsSample[];
  public readonly dominantColor: string;
  public readonly otherColor: string[];
  public readonly odorStrength: string;
  public readonly odorDescription: string;

  public static DEFAULT_CONFIG: PhysicalComponent = {
    physicalComponents: [],
    dominantColor: '',
    otherColor: [],
    odorStrength: '',
    odorDescription: '',
  };

  constructor(config?: PhysicalComponent) {
    this.physicalComponents = config
      ? this.createPhysicalComponentSamples(config.physicalComponents)
      : PhysicalComponentModel.DEFAULT_CONFIG.physicalComponents;
    this.dominantColor = config
      ? DomainModelHelper.ensureDataIsString(config.dominantColor)
      : PhysicalComponentModel.DEFAULT_CONFIG.dominantColor;
    this.otherColor = config
      ? DomainModelHelper.ensureDataIsStringArray(config.otherColor)
      : PhysicalComponentModel.DEFAULT_CONFIG.otherColor;
    this.odorStrength = config
      ? DomainModelHelper.ensureDataIsString(config.odorStrength)
      : PhysicalComponentModel.DEFAULT_CONFIG.odorStrength;
    this.odorDescription = config
      ? DomainModelHelper.ensureDataIsString(config.odorDescription)
      : PhysicalComponentModel.DEFAULT_CONFIG.odorDescription;
  }

  protected createPhysicalComponentSamples(
    physicalComponentConfig: PhysicalComponentsSample[]
  ): PhysicalComponentsSample[] {
    if (!Array.isArray(physicalComponentConfig)) {
      return [];
    }

    return physicalComponentConfig
      .filter((sample) => !!sample)
      .map((sample) => new PhysicalComponentsSampleModel(sample))
      .filter((sample) => !sample.isEmpty());
  }
}

export class PhysicalComponentsSampleModel implements PhysicalComponentsSample {
  public readonly name: string;
  public readonly typicalOrActualPercent: number;
  public readonly lowPercent: number;
  public readonly highPercent: number;

  public static DEFAULT_CONFIG: PhysicalComponentsSample = {
    name: '',
    typicalOrActualPercent: null,
    lowPercent: null,
    highPercent: null,
  };

  constructor(config?: PhysicalComponentsSample) {
    this.name = config
      ? DomainModelHelper.ensureDataIsString(config.name)
      : PhysicalComponentsSampleModel.DEFAULT_CONFIG.name;
    this.typicalOrActualPercent = config
      ? DomainModelHelper.ensureDataIsNumber(config.typicalOrActualPercent)
      : PhysicalComponentsSampleModel.DEFAULT_CONFIG.typicalOrActualPercent;
    this.lowPercent = config
      ? DomainModelHelper.ensureDataIsNumber(config.lowPercent)
      : PhysicalComponentsSampleModel.DEFAULT_CONFIG.lowPercent;
    this.highPercent = config
      ? DomainModelHelper.ensureDataIsNumber(config.highPercent)
      : PhysicalComponentsSampleModel.DEFAULT_CONFIG.highPercent;
  }

  public isEmpty(): boolean {
    return (
      !this.name &&
      !this.typicalOrActualPercent &&
      !this.lowPercent &&
      !this.highPercent
    );
  }
}
